// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cardSpaceModuleLg {\n  width: 50vw;\n  border-radius: 5px;\n  margin-bottom: auto;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 15px 30px 30px 30px;\n  text-align: center;\n  background: #fafafa;\n}\n\n.cardSpaceModuleLg:hover {\n  transition: box-shadow 0.3s;\n  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);\n}\n\n.customBadge {\n  width: 7rem;\n  font-weight: 300 !important;\n}\n\n.hand-cursor {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
